import { IChannelCareState } from '.';
import { AsyncActions } from '../../standard-actions/';

export const initialState: Readonly<IChannelCareState> = Object.freeze({
    cases: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            cases: [],
            original_cases: [],
            fetchTime: new Date().getTime()
        },
        filter: {
            submittedBy: []
        },
        selectedCompanyId: ''
    },
    selectedFilters: {
        status: [],
        assignedTo: [],
        dates: [],
        selectedDateInput: [],
        submittedBy: [],
    },
    casesInt: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            cases: [],
        }
    },
    formconfig: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: [],
            status: 200
        },
    },
    summary: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            openCases: 0,
        }
    },
    submitEnquiry: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            caseId: '',
        }
    },
    addComment: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            number: '',
            createdDate: ''
        }
    },
    adjustmentList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    invoiceList: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    caseDetails: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: {
                number: '',
                createdDate: '',
                subject: '',
                status: '',
                subStatus: '',
                CIDN: '',
                queriedAmount: '',
                determinationAmount: 0,
                description: '',
                owner: '',
                contact: '',
                additionalInfo: {},
                telstraAttachments: [],
                yourAttachments: []
            }
        }
    },
    caseActivity: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: {
                caseNumber: '',
                currentStatus: '',
                comments: []
            }
        }
    },
    accounts: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            billingAccounts: [{
                name: '',
                value: '',
                isLegacy: undefined

            }],
            cidn: ''
        }
    },
    company: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            name: '',
            id: 0,
            cidn: ''
        }
    },
    deleteAttachments: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    fileUploads: {
        data: [],
        status: AsyncActions.AsyncActionState.NotStarted
    },
    attachmentRequest: {
        status: AsyncActions.AsyncActionState.NotStarted
    },
    attachmentsList: [],
    submitForm: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: {
                number: '',
                caseId: '',
                createdDate: ''
            },
            status: 200
        }
    },
    customerContact: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: [],
            status: 200
        },
    },
    caseAttachments: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: null
    },
    orderRefrences: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: []
    },
    selectedSort: {
        id: 'number',
        desc: false
    },
    companyMultiCidn: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: []
        }
    },
    companies: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            data: []
        }
    },
    casesSummary: {
        status: AsyncActions.AsyncActionState.NotStarted,
        data: {
            casesNew: 0,
            casesInProgress: 0,
            casesOnHold: 0,
            casesWithdrawn: 0,
            casesRejected: 0,
            casesClosed: 0,
            casesResolved: 0,
            casesTotal: 0
        }
    },
});
